import React from 'react';

const LogoComponent = (props) => {
    return (
        <div>
            <img src={require('../../assets/imgs/logo.png')} height={props.height} width={props.width} />
        </div>
    )
}

export default LogoComponent;